export const hostnames = [
  'alpha.intentfi.io',
  'anvil.localhost',
  'app.cashmere.exchange',
  'app.ens.domains',
  'app.uniswap.org',
  'authentication-pwa.porto.workers.dev',
  'authentication-rainbowkit.porto.workers.dev',
  'bluestake.vercel.app',
  'bungee.exchange',
  'cartel.sh',
  'cctp.exchange',
  'cut-v2.mattlovan.dev',
  'daimo.ngrok.app',
  'eco.com',
  'garden.staging.btcfi.wtf',
  'happypath.enso.build',
  'id.porto.sh',
  'jumper.exchange',
  'localhost',
  'mainnet.cashmere.exchange',
  'news.kiwistand.com',
  'o.bun-alewife.ts.net',
  'paper.ink',
  'pay.daimo.com',
  'playground.li.fi',
  'playground.porto.sh',
  'portal.eco.com',
  'porto-react-native.ngrok.io',
  'porto.sh',
  'postcaptain.xyz',
  'preview.porto.sh',
  'rath.fi',
  'relay.link',
  'sponsor-porto.vercel.app',
  'sponsoring-privy.porto.workers.dev',
  'staging.kiwistand.com',
  'stg.localhost',
  'sushi.com',
  'swap.defillama.com',
  'uniswap.org',
  'www.bungee.exchange',
  'wallet.risechain.com',
  'risechain.com',
  'testnet.rise.trade',
  'dev.rise.trade',
  'rise.trade',
]
